import { countryUpdated } from '../config/CountryUpadated';
import { unitedStatesStates } from '../config/UsaStates';
import { previousSearchSxs } from 'src/content/keywordResearch/keywordResearchCSS';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import {
  KeywordTrackingAnalyzeCss,
  KeywordTrackingResultTableCss
} from 'src/content/keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { KeywordOverviewTableCss } from 'src/content/keywordResearch/keywordOverview/keywordOverviewCSS';
import { removeNegativeSign } from '../config/FunctionHelperPartTwo';
import { formatNumberWithCommas } from '../config/FunctionHelper';

export const PdfKeywordTrackingRow = ({ row, index }) => {
  // Find the USA object from `countryUpdated`
  const usaIndex = countryUpdated?.findIndex(
    (c) => c?.name === 'United States'
  );
  // Insert U.S. states after USA object dynamically
  const updatedCountryList = [
    ...countryUpdated?.slice(0, usaIndex + 1), // Keep everything before and including USA
    ...unitedStatesStates, // Add US states after USA
    ...countryUpdated?.slice(usaIndex + 1) // Keep the rest of the countries
  ];
  const locationCode = row?.locationCode
    ? updatedCountryList?.find(
        (country) => country?.locationId === row?.locationCode
      )?.code || '-'
    : '-';
  const locationName = row?.locationCode
    ? updatedCountryList.find(
        (country) => country?.locationId === row?.locationCode
      )?.name || '-'
    : '-';

  return (
    <>
      <TableRow
        hover
        role="checkbox"
        key={row?._id} // Changed from row.name to row.keywords
        sx={{
          backgroundColor: 'transparent'
        }}
      >
        <TableCell
          sx={{
            // ...KeywordOverviewTableCss?.tableCellText,
            ...KeywordOverviewTableCss?.keywordTextCell,
            ...KeywordOverviewTableCss?.tableCellPadding,
            cursor: 'pointer',
            width: '35%'
            // ...KeywordOverviewTableCss?.keywordCell
          }}
          align="left"
        >
          {row?.keyword || '-'}
        </TableCell>
        <TableCell
          sx={{
            ...KeywordOverviewTableCss?.tableCellPadding,
            ...KeywordOverviewTableCss?.tableCellText,
            width: '16rem',
            maxWidth: '16rem'
          }}
          align="left"
        >
          <img
            src={`/static/images/icons/${
              row?.device == 'mobile' ? 'mobile' : 'desktop'
            }.svg`} // Replace with your actual image path
            alt="icon"
            style={KeywordTrackingAnalyzeCss?.imgStyle} // Adjust size as needed
          />
        </TableCell>
        <TableCell
          sx={{
            ...KeywordOverviewTableCss?.tableCellPadding,
            ...KeywordOverviewTableCss?.tableCellText,
            width: '16rem',
            maxWidth: '16rem'
          }}
          align="left"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                marginRight: 1,
                backgroundColor:
                  row?.position >= 1 && row?.position <= 3
                    ? '#33DBBA'
                    : row?.position >= 4 && row?.position <= 10
                    ? '#167E6A'
                    : row?.position >= 11 && row?.position <= 20
                    ? '#0E5245'
                    : row?.position >= 21
                    ? '#072721'
                    : ''
              }}
            />
            <Typography sx={previousSearchSxs?.numbersSx}>
              {row?.position || '-'}
            </Typography>
            {row?.position &&
            row?.previousPosition !== null &&
            row?.previousPosition !== undefined ? (
              <Typography sx={KeywordTrackingResultTableCss?.prePositionSx}>
                {`(${row?.previousPosition})`}
              </Typography>
            ) : null}
            {row?.position &&
            row?.comparePosition &&
            row?.comparePosition !== 0 ? (
              <Box sx={KeywordTrackingResultTableCss?.positionChangeBox}>
                <img
                  src={`/static/images/icons/${
                    row?.comparePosition < 0
                      ? 'red-down-arrow'
                      : 'green-up-arrow'
                  }.svg`}
                  alt="icon"
                />
                <Typography
                  sx={{
                    color: row?.comparePosition < 0 ? '#D92D20' : '#1A927B',
                    ...KeywordTrackingResultTableCss?.positionChangeTextSx
                  }}
                >
                  {removeNegativeSign(row?.comparePosition)}
                </Typography>
              </Box>
            ) : null}
          </Box>
        </TableCell>
        <TableCell
          sx={{
            ...KeywordOverviewTableCss?.tableCellPadding,
            ...KeywordOverviewTableCss?.tableCellText,
            width: '12rem',
            maxWidth: '12rem'
          }}
          align="left"
        >
          <Typography sx={previousSearchSxs?.dateSx}>
            {row?.volume !== '' && row?.volume !== null
              ? formatNumberWithCommas(row?.volume)
              : '-'}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            ...KeywordOverviewTableCss?.tableCellPadding,
            ...KeywordOverviewTableCss?.tableCellText,
            paddingRight: '10px !important',
            minWidth: '11rem',
            width: '16rem',
            maxWidth: '16rem'
          }}
          align="left"
        >
          <Box sx={KeywordTrackingResultTableCss?.locationBoxSx}>
            <img
              width="20"
              height="20"
              src={`https://flagcdn.com/${locationCode.toLowerCase()}.svg`}
              alt=""
              style={{
                objectFit: 'cover',
                ...KeywordTrackingResultTableCss?.locationIcon
              }}
            />
            <Typography
              sx={{ minWidth: 'fit-content', ...previousSearchSxs?.dateSx }}
            >
              {locationName || '-'}
            </Typography>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};
